// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DatabaseOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/DatabaseOutlined';
import DashboardOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import BarChartOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/BarChartOutlined';
import GoldOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/GoldOutlined';
import PartitionOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/PartitionOutlined';
import ApartmentOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/ApartmentOutlined';
import TeamOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/TeamOutlined';
import SettingOutlined from 'D:/a/1/s/UI/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { DatabaseOutlined, DashboardOutlined, BarChartOutlined, GoldOutlined, PartitionOutlined, ApartmentOutlined, TeamOutlined, SettingOutlined };
